import Box, {Item} from "devextreme-react/box";
import {useContext} from "react";
import {QuoteStatus} from "../../../../types/enums";
import {EstimateContext} from "../context/EstimateContext";
import CustomerInformationCard from "./CustomerInformationCard";
import PendingOrderCard from "./PendingOrderCard";
import EstimateInformationCard from "./EstimateInformationCard";
import StoreInformationCard from "./StoreInformationCard";

export default function EstimateInformationCards() {

	const { order } = useContext(EstimateContext);

	return (
		<>
			{
				order.details.statusID === QuoteStatus.Pending ?
					<PendingOrderCard />
					:
					<Box className='order-cards'>
						<Item ratio={1}>
							<EstimateInformationCard />
						</Item>
						<Item ratio={1}>
							<CustomerInformationCard />
						</Item>
						<Item ratio={1}>
							<StoreInformationCard />
						</Item>
					</Box>
			}
		</>
	)
}
